<template>
  <div>
    <el-card shadow="always">
      <el-button size="small" type="primary" @click="addData">添加</el-button>
      <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
    </el-card>
    <el-table height="600" size="small" :data="tableData" border :default-expand-all="false" row-key="id" class="box-card mt10">
      <el-table-column prop="name" label="菜单名称" width="220"> </el-table-column>
      <el-table-column prop="id" label="ID" width="80"> </el-table-column>
      <el-table-column prop="route" label="路由" width="200"> </el-table-column>
      <el-table-column label="图标" width="60">
        <template slot-scope="scope">
          <i :class="scope.row.icon"></i>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="80"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="editData(scope.row)">编辑</el-button>
          <el-button size="mini" type="warning" @click="delData(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <menu-save ref="menuSaveRef" @callMethod="refresh"></menu-save>
    </el-dialog>
  </div>
</template>

<script>
import MenuSave from '@/components/auth/menuSave.vue';
export default {
  name: 'authMenu',
  components: {
    MenuSave
  },
  inject: ['reload'],
  created() {
    this.getData();
  },
  data() {
    return {
      dialogTitle: '',
      dialogShow: false,
      tableData: []
    };
  },
  methods: {
    async getData() {
      await this.$api.auth.menuList().then(res => {
        if (res.code == 200) {
          this.tableData = res.data ? res.data : [];
        }
      });
    },
    addData() {
      this.dialogTitle = '添加菜单';
      this.dialogShow = true;
      this.$nextTick(() => {
        this.$refs.menuSaveRef.setData(this.tableData);
      });
    },
    editData(menuData) {
      this.dialogTitle = '编辑菜单';
      this.dialogShow = true;
      this.$nextTick(() => {
        this.$refs.menuSaveRef.setData(this.tableData, menuData);
        this.reload();
      });
    },
    async delData(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$api.auth.menuDelete({ id: id }).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.getData();
              this.reload();
            }
          });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    refresh() {
      this.dialogShow = false;
      this.getData();
    }
  }
};
</script>
